/**
 * Relieve: CTA-knapper.
 *
 * Peger en CTA paa praecis den side, man allerede staar paa - typisk
 * "Se Migraenemasken" nede paa selve produktsiden - saa genindlaeser vi ikke
 * siden. Vi ruller blidt op til toppen i stedet.
 *
 * Alt andet passerer uroert: eksterne links, nye faner, ankre og alt med
 * query-parametre (variantskift, filtre, UTM).
 */
(function () {
  if (window.__rlvCtaBound) return;
  window.__rlvCtaBound = true;

  function norm(path) {
    return path.replace(/\/+$/, '') || '/';
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    if (link.hasAttribute('download')) return;
    if (link.hasAttribute('data-rlv-no-scroll')) return;

    var target = link.getAttribute('target');
    if (target && target !== '' && target !== '_self') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    if (url.search !== '') return;
    if (url.hash !== '') return;
    if (norm(url.pathname) !== norm(window.location.pathname)) return;

    event.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
